// Import the environment configuration from the original project
// API Configuration
export const API_BASE_URL = import.meta.env.PROD ? window.location.origin : '';

export const ENV = {
    API_BASE_URL: API_BASE_URL+"/api/v1",
    API_BASE_URL_CUSTOM:  API_BASE_URL+"/btsmapi",
}; 